import PropTypes from 'prop-types';

const sidebarPropTypes = {
    /** Callback when onLayout of sidebar is called */
    onLayout: PropTypes.func,
};
export default sidebarPropTypes;
